@if (formGroup) {
	<app-searchable-dropdown-control
		[fg]="formGroup"
		[formGroupOrControlName]="formGroupOrControlName"
		[label]="label"
		[placeholder]="placeholder || 'Search by student name...'"
		[noLabel]="noLabel"
		[options]="options()"
		[loading]="loading()"
		(onSearch)="onSearch($event)"
		(onChange)="onChange($event)"
	></app-searchable-dropdown-control>
}
